export default __webpack_public_path__ + "static/media/36I-114277_-20862_0.397d6b6a.jpg";